import { Redirect, useLocalSearchParams } from 'expo-router';

// Legacy compatibility route:
// old creator links used /learn/creator/[courseId].
// Canonical creator management now uses a world id in the same segment.
export default function LegacyCreatorCourseIdRedirect() {
  const { courseId } = useLocalSearchParams<{ courseId?: string | string[] }>();
  const canonicalId = Array.isArray(courseId) ? courseId[0] : courseId;
  return <Redirect href={canonicalId ? `/learn/creator/manage/${encodeURIComponent(canonicalId)}` : '/learn/creator'} />;
}
